import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeCustomer = gql`

    type CustomerBaseFields {
        id: ID
        billingInformation: CustomerBaseBillingInformation
        contactData: CustomerBaseContactData
        taxComplianceData: CustomerBaseTaxComplianceData
        otherData: CustomerBaseOtherData
    }

    type CustomerBaseBillingInformation {
        companyName: String
        postalCode: String
        streetName: String
        additionalStreetInfo: String
        city: String
        pOBox: String
    }

    type CustomerBaseContactData {
        phoneNumber: String
        mobileNumber: String
        fax: String
        email: String
    }

    type CustomerBaseTaxComplianceData {
        vatId: String
        intrastatDeclaration: String
        dic: String
        ico: String
    }

    type CustomerSearchResult {
        id: ID,
        customerNumber: String,
        companyName: String,
        matchCode: String,
        customerBranch: String,
        city: String,
        streetName: String,
        postalCode: String,
        customerClassification: String,
        branchId: String,
        branchTitle: String,
        admRepresentative: String,
    }

    type CustomerBaseOtherData {
        associationNumber: String
        dataExchangeSystem: String
        tourNumber: String
        truckTourNumber: String
        invoiceEmail: String
        customerClassification: String
        vatKey: String
        collectiveInvoiceKey: String
        paymentMethod: String
        dunningKey: String
        dunningBlock: Boolean
        orderConfirmation: String
        admSalesRepresentive: String
        expertAdvisor: String
        insideServiceEmployee: String
        einzaCreditLimit: Float
        hermesCreditInsurance: Boolean
        hermesCreditLimit: Float
        hermesLimitMaximum: Boolean
        offerAvailable: Boolean
        notify: Boolean
        recordOrderNumberOnDeliveryNote: Boolean
        printSellingPrice: Boolean
        controlInvoices: Boolean
        processingFee: Boolean
        freightSurcharge: Boolean
        underInvoicing: Boolean
        webShopCustomer: Boolean
        installmentPayment: Boolean
        lawyerHired: Boolean
        legalSettlement: Boolean
        bankcruptcy: Boolean
        orderConfirmationEmail: String
        branchName: String
        skontoText: String
        status: String
        costUnitMandatory: Boolean
    }

    type CustomerCustomFields {
        customerBranchId: String
        customerClassification: String
        tourNumber: String
        admSalesRepresentive: String
        paymentMethod: String
        einzaCreditLimit: Float
        currentYearRevenueData: YearRevenue
        lastYearRevenueData: YearRevenue
        matchCode: String
        branchTitle: String
        customerStatus: String
    }

    type CustomerAddress {
        id: ID
        streetName: String
        additionalStreetInfo: String
        postalCode: String
        city: String
        country: String
        company: String
        phone: String
        mobile: String
        email: String
        fax: String
        key: String
    }

    type Customer {
        id: ID
        version: Int
        key: String

        createdAt: DateTime
        createdBy: JSON
        lastModifiedAt: DateTime
        lastModifiedBy: JSON

        customerNumber: String
        externalId: ID

        email: EmailAddress
        firstName: String
        lastName: String
        middleName: String
        title: String
        dateOfBirth: String
        companyName: String
        vatId: String

        addresses: [JSONObject]
        defaultShippingAddressId:String
        defaultBillingAddressId:String
        shippingAddressIds:[String]
        billingAddressIds: [String]

        isEmailVerified: Boolean
        customerGroup: JSON

        locale: Locale
        salutation: String
        stores: [JSONObject]
        authenticationMode: JSON
        channel: JSON

        customFields: CustomerCustomFields
        customAdmFields: AdmFields
        customCustomerCharacteristics: CustomerCharacteristics
        defaultBillingAddress: CustomerAddress
        isInternal: Boolean
    }

    type CustomerCharacteristics {
        numberOfEmployees: String
        businessVolume: String
        customers: String
        memberships: String
        activeCompetitors: String
        foundingDate: String
    }

    type Customers {
        limit: Int
        offset: Int
        count: Int
        total: Int

        items: [Customer]
    }

    type CustomerSearchResults {
        limit: Int
        offset: Int
        count: Int
        total: Int
        page: Int

        items: [CustomerSearchResult]
    }

    type Query {
        customer(
            customerNumber: String!
            includeRevenue: Boolean = false
            year: Int
            internalCheck: Boolean = false
        ): Customer

        customers(
            offset: Int = ${DEFAULTS.QUERY.OFFSET}
            limit: Int = ${DEFAULTS.QUERY.LIMIT}
            sort: Sort
            admNumber: String = null
        ): Customers!

        customerBaseInformation(
            customerNumber: String!  
        ): CustomerBaseFields

        allAssignedCustomers(includeRevenue: Boolean = false): [Customer]
        idmCustomers(
            offset: Int = ${DEFAULTS.QUERY.OFFSET}
            limit: Int = ${DEFAULTS.QUERY.LIMIT}
            branchId: String
            searchTerm: String
            page: Int
            internalSearch: Boolean
        ): CustomerSearchResults
        customersListCheck(
            offset: Int = ${DEFAULTS.QUERY.OFFSET}
            limit: Int = ${DEFAULTS.QUERY.LIMIT}
            searchTerm: String
            page: Int
        ): CustomerSearchResults
    }

    input CustomerCharacteristicsValues {
        numberOfEmployees: String
        businessVolume: String
        customers: String
        memberships: String
        activeCompetitors: String
        foundingDate: String
    }

    type Mutation {
        updateCustomerCharacteristics(
            customerId: ID
            customerKey: String
            values: CustomerCharacteristicsValues
        ): Customer
    }
`

export { typeCustomer }

export default typeCustomer
